import { ADD_FLASH_MESSAGE, REMOVE_FLASH_MESSAGE } from './actionTypes';

export const addFlashMessage = (payload: { type: string; message: string; isRemained?: true }) => ({
  type: ADD_FLASH_MESSAGE,
  payload,
});

export const removeFlashMessage = (payload: number) => ({
  type: REMOVE_FLASH_MESSAGE,
  payload,
});
